import { SVGProps } from 'react';

interface IProps {
  color?: string;
}

export const FileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    color={props.color || 'rgba(16, 71, 220, 1)'}
  >
    <path
      d="M11.875 8.5C11.875 8.59946 11.8355 8.69484 11.7652 8.76517C11.6948 8.83549 11.5995 8.875 11.5 8.875H9.875V10.125H11C11.0995 10.125 11.1948 10.1645 11.2652 10.2348C11.3355 10.3052 11.375 10.4005 11.375 10.5C11.375 10.5995 11.3355 10.6948 11.2652 10.7652C11.1948 10.8355 11.0995 10.875 11 10.875H9.875V12C9.875 12.0995 9.83549 12.1948 9.76517 12.2652C9.69484 12.3355 9.59946 12.375 9.5 12.375C9.40055 12.375 9.30516 12.3355 9.23484 12.2652C9.16451 12.1948 9.125 12.0995 9.125 12V8.5C9.125 8.40054 9.16451 8.30516 9.23484 8.23484C9.30516 8.16451 9.40055 8.125 9.5 8.125H11.5C11.5995 8.125 11.6948 8.16451 11.7652 8.23484C11.8355 8.30516 11.875 8.40054 11.875 8.5ZM3.625 9.75C3.625 10.181 3.4538 10.5943 3.14905 10.899C2.8443 11.2038 2.43098 11.375 2 11.375H1.375V12C1.375 12.0995 1.33549 12.1948 1.26517 12.2652C1.19484 12.3355 1.09946 12.375 1 12.375C0.900544 12.375 0.805161 12.3355 0.734835 12.2652C0.664509 12.1948 0.625 12.0995 0.625 12V8.5C0.625 8.40054 0.664509 8.30516 0.734835 8.23484C0.805161 8.16451 0.900544 8.125 1 8.125H2C2.43098 8.125 2.8443 8.29621 3.14905 8.60095C3.4538 8.9057 3.625 9.31902 3.625 9.75ZM2.875 9.75C2.875 9.51794 2.78281 9.29538 2.61872 9.13128C2.45462 8.96719 2.23206 8.875 2 8.875H1.375V10.625H2C2.23206 10.625 2.45462 10.5328 2.61872 10.3687C2.78281 10.2046 2.875 9.98207 2.875 9.75ZM8.125 10.25C8.125 10.8136 7.90112 11.3541 7.5026 11.7526C7.10409 12.1511 6.56359 12.375 6 12.375H5C4.90054 12.375 4.80516 12.3355 4.73484 12.2652C4.66451 12.1948 4.625 12.0995 4.625 12V8.5C4.625 8.40054 4.66451 8.30516 4.73484 8.23484C4.80516 8.16451 4.90054 8.125 5 8.125H6C6.56359 8.125 7.10409 8.34888 7.5026 8.7474C7.90112 9.14591 8.125 9.68642 8.125 10.25ZM7.375 10.25C7.375 9.88533 7.23014 9.53559 6.97227 9.27773C6.71441 9.01987 6.36467 8.875 6 8.875H5.375V11.625H6C6.36467 11.625 6.71441 11.4801 6.97227 11.2223C7.23014 10.9644 7.375 10.6147 7.375 10.25ZM0.625 6V1.5C0.625 1.26794 0.717187 1.04538 0.881282 0.881282C1.04538 0.717187 1.26794 0.625 1.5 0.625H7.5C7.54934 0.624961 7.59819 0.634658 7.64377 0.653533C7.68935 0.672409 7.73076 0.700094 7.76563 0.735L11.2656 4.235C11.3357 4.30536 11.3751 4.40067 11.375 4.5V6C11.375 6.09946 11.3355 6.19484 11.2652 6.26517C11.1948 6.33549 11.0995 6.375 11 6.375C10.9005 6.375 10.8052 6.33549 10.7348 6.26517C10.6645 6.19484 10.625 6.09946 10.625 6V4.875H7.5C7.40054 4.875 7.30516 4.83549 7.23484 4.76517C7.16451 4.69484 7.125 4.59946 7.125 4.5V1.375H1.5C1.46685 1.375 1.43505 1.38817 1.41161 1.41161C1.38817 1.43505 1.375 1.46685 1.375 1.5V6C1.375 6.09946 1.33549 6.19484 1.26517 6.26517C1.19484 6.33549 1.09946 6.375 1 6.375C0.900544 6.375 0.805161 6.33549 0.734835 6.26517C0.664509 6.19484 0.625 6.09946 0.625 6ZM7.875 4.125H10.095L7.875 1.905V4.125Z"
      fill="#1047DC"
    />
  </svg>
);

export const ApprovedOutlined = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2344 7.3463L7.2001 10.3806L6.16578 9.3463M8.0001 2.38062C4.46548 2.38062 1.6001 5.24599 1.6001 8.78061C1.6001 12.3152 4.46548 15.1806 8.0001 15.1806C11.5347 15.1806 14.4001 12.3152 14.4001 8.78061C14.4001 5.24599 11.5347 2.38062 8.0001 2.38062Z"
        stroke="#36913F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RejectedOutlined = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6163 6.09079C10.8116 5.89553 10.8116 5.57894 10.6163 5.38368C10.421 5.18842 10.1045 5.18842 9.90919 5.38368L10.6163 6.09079ZM5.3837 9.90916C5.18844 10.1044 5.18844 10.421 5.3837 10.6163C5.57897 10.8115 5.89555 10.8115 6.09081 10.6163L5.3837 9.90916ZM9.90919 10.6163C10.1045 10.8115 10.421 10.8115 10.6163 10.6163C10.8116 10.421 10.8116 10.1044 10.6163 9.90916L9.90919 10.6163ZM6.09081 5.38368C5.89555 5.18842 5.57897 5.18842 5.3837 5.38368C5.18844 5.57894 5.18844 5.89552 5.3837 6.09079L6.09081 5.38368ZM13.9 7.99998C13.9 11.2585 11.2585 13.9 8 13.9V14.9C11.8108 14.9 14.9 11.8107 14.9 7.99998H13.9ZM8 13.9C4.74152 13.9 2.1 11.2585 2.1 7.99998H1.1C1.1 11.8107 4.18924 14.9 8 14.9V13.9ZM2.1 7.99998C2.1 4.7415 4.74152 2.09998 8 2.09998V1.09998C4.18924 1.09998 1.1 4.18921 1.1 7.99998H2.1ZM8 2.09998C11.2585 2.09998 13.9 4.7415 13.9 7.99998H14.9C14.9 4.18921 11.8108 1.09998 8 1.09998V2.09998ZM9.90919 5.38368L7.64645 7.64642L8.35355 8.35353L10.6163 6.09079L9.90919 5.38368ZM7.64645 7.64642L5.3837 9.90916L6.09081 10.6163L8.35355 8.35353L7.64645 7.64642ZM10.6163 9.90916L8.35355 7.64642L7.64645 8.35353L9.90919 10.6163L10.6163 9.90916ZM8.35355 7.64642L6.09081 5.38368L5.3837 6.09079L7.64645 8.35353L8.35355 7.64642Z"
        fill="#BA1C1C"
      />
    </svg>
  );
};

export const MessageAlertIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99961 10.4001V8.0001M7.99961 5.6001V5.66025M14.3996 8.0001C14.3996 8.92012 14.2055 9.79479 13.856 10.5854L14.4008 14.3995L11.1322 13.5823C10.2062 14.1031 9.13761 14.4001 7.99961 14.4001C4.46499 14.4001 1.59961 11.5347 1.59961 8.0001C1.59961 4.46548 4.46499 1.6001 7.99961 1.6001C11.5342 1.6001 14.3996 4.46548 14.3996 8.0001Z"
      stroke="#676B76"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownArrow = ({ color }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7991 4.91314L11.7992 11.8M11.7992 11.8H5.01035M11.7992 11.8L4.19922 4.19995"
        stroke="#BA1C1C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UpArrow = ({ color }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.91241 4.20005L11.7992 4.19995M11.7992 4.19995V10.9888M11.7992 4.19995L4.19922 11.8"
        stroke="#36913F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DotIcon = ({ color }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="4"
      viewBox="0 0 4 4"
      fill="none"
    >
      <circle cx="2" cy="2" r="2" fill={color} />
    </svg>
  );
};

export const SearchIcon = ({ color }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66654 2.66732C4.4574 2.66732 2.66654 4.45818 2.66654 6.66732C2.66654 8.87646 4.4574 10.6673 6.66654 10.6673C8.87568 10.6673 10.6665 8.87646 10.6665 6.66732C10.6665 4.45818 8.87568 2.66732 6.66654 2.66732ZM1.33321 6.66732C1.33321 3.7218 3.72102 1.33398 6.66654 1.33398C9.61206 1.33398 11.9999 3.7218 11.9999 6.66732C11.9999 7.89979 11.5818 9.03463 10.8798 9.93775L14.4713 13.5292C14.7316 13.7896 14.7316 14.2117 14.4713 14.4721C14.2109 14.7324 13.7888 14.7324 13.5285 14.4721L9.93697 10.8806C9.03385 11.5826 7.89901 12.0007 6.66654 12.0007C3.72102 12.0007 1.33321 9.61284 1.33321 6.66732Z"
        fill={color || '#999DA8'}
      />
    </svg>
  );
};

export const UserProfileIcon = ({ color }: IProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="users-profiles-01">
      <path
        id="Icon"
        d="M10.6836 13.7139L10.6838 11.5714C10.6839 10.3879 9.72453 9.42848 8.54107 9.42848H3.74292C2.55963 9.42848 1.60035 10.3877 1.60022 11.5709L1.59998 13.7139M14.3998 13.714L14.4 11.5715C14.4001 10.388 13.4407 9.4286 12.2573 9.4286M10.2709 2.70707C10.7971 3.0975 11.1381 3.7234 11.1381 4.42895C11.1381 5.13451 10.7971 5.76041 10.2709 6.15084M8.32917 4.42884C8.32917 5.61222 7.36985 6.57154 6.18647 6.57154C5.00309 6.57154 4.04377 5.61222 4.04377 4.42884C4.04377 3.24545 5.00309 2.28613 6.18647 2.28613C7.36985 2.28613 8.32917 3.24545 8.32917 4.42884Z"
        stroke={color ?? '#676B76'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const InformationCircleIcon = ({ color }: IProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="information-circle-contained">
      <path
        id="Icon"
        d="M7.99998 7.99961L7.99997 11.1996M7.99998 5.62773V5.59961M1.59998 7.99961C1.59998 4.46499 4.46535 1.59961 7.99998 1.59961C11.5346 1.59961 14.4 4.46499 14.4 7.99961C14.4 11.5342 11.5346 14.3996 7.99997 14.3996C4.46535 14.3996 1.59998 11.5342 1.59998 7.99961Z"
        stroke={color ?? '#676B76'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const FileShieldIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.79999 14.3996H5.19999C3.8745 14.3996 2.79999 13.3251 2.79999 11.9996V3.99961C2.79999 2.67413 3.8745 1.59961 5.19999 1.59961H10.8C12.1255 1.59961 13.2 2.67413 13.2 3.99961V5.99961M10.4 4.79961H5.19999M7.99999 7.19961H5.19999M6.79999 9.59961H5.19999M9.19999 9.79961L10.1267 9.33626C10.8023 8.99843 11.5976 8.99843 12.2733 9.33627L13.2 9.79961C13.2 9.79961 13.2 11.2596 13.2 12.0296C13.2 12.7996 12.4882 13.3194 11.2 14.1329C9.91176 13.3194 9.19999 12.6329 9.19999 12.0296V9.79961Z"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileCheckIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.59987 14.3996H3.39986C2.5162 14.3996 1.79986 13.6832 1.79987 12.7996L1.79993 3.1996C1.79993 2.31595 2.51628 1.59961 3.39993 1.59961H10.6001C11.4838 1.59961 12.2001 2.31595 12.2001 3.19961V7.59961M9.00012 12.1329L10.4668 13.5996L14.2001 9.59961"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const FileDownIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.1999 14.3996H3.9999C3.11624 14.3996 2.3999 13.6832 2.3999 12.7996L2.39996 3.1996C2.39997 2.31595 3.11631 1.59961 3.99996 1.59961H11.2001C12.0838 1.59961 12.8001 2.31595 12.8001 3.19961V7.59961M13.6002 12.7712L11.964 14.3996M11.964 14.3996L10.4002 12.8448M11.964 14.3996V10.3996M5.20015 4.79961H10.0002M5.20015 7.19961H10.0002M5.20015 9.59961H7.60015"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileLockIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.79999 6.79961V5.99961C6.79999 5.33687 7.33725 4.79961 7.99999 4.79961C8.66273 4.79961 9.19999 5.33687 9.19999 5.99961V7.19961M2.79999 11.9996V3.99961C2.79999 2.67413 3.8745 1.59961 5.19999 1.59961H10.8C12.1255 1.59961 13.2 2.67413 13.2 3.99961V11.9996C13.2 13.3251 12.1255 14.3996 10.8 14.3996H5.19999C3.8745 14.3996 2.79999 13.3251 2.79999 11.9996ZM6.39999 11.1996H9.59999C10.0418 11.1996 10.4 10.8414 10.4 10.3996V7.99961C10.4 7.55778 10.0418 7.19961 9.59999 7.19961H6.39999C5.95816 7.19961 5.59999 7.55778 5.59999 7.99961V10.3996C5.59999 10.8414 5.95816 11.1996 6.39999 11.1996Z"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShieldCheckIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.40001 7.45891L7.60001 8.65891L10 6.25891M3.20001 3.85891L6.9267 1.99556C7.60237 1.65773 8.39766 1.65773 9.07332 1.99556L12.8 3.85891C12.8 3.85891 12.8 7.36291 12.8 9.21091C12.8 11.0589 11.0917 12.3064 8.00001 14.2589C4.90828 12.3064 3.20001 10.6589 3.20001 9.21091V3.85891Z"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileReturnIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.9999 14.3996H2.9999C2.11624 14.3996 1.3999 13.6832 1.3999 12.7996L1.39996 3.1996C1.39997 2.31595 2.11631 1.59961 2.99996 1.59961H10.2001C11.0838 1.59961 11.8001 2.31595 11.8001 3.19961V6.39961M4.20015 4.79961H9.00015M4.20015 7.19961H9.00015M4.20015 9.59961H6.60015M10.2285 13.5996L8.60015 11.9634M8.60015 11.9634L10.1549 10.3996M8.60015 11.9634H13.4182C14.071 11.9634 14.6002 11.4343 14.6002 10.7815C14.6002 10.1288 14.071 9.59961 13.4182 9.59961H11.8002"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CardEditIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.00066 10.4398L0.500659 10.4398L1.00066 10.4398ZM1.00049 4.43989L1.50049 4.43987L1.00049 4.43989ZM7.80043 12.5398C8.07658 12.5398 8.30044 12.316 8.30044 12.0399C8.30045 11.7637 8.07659 11.5398 7.80045 11.5398L7.80043 12.5398ZM2.60063 12.0397L2.60064 11.5397H2.60064L2.60063 12.0397ZM13.8001 4.43907L13.3001 4.43908V4.43908L13.8001 4.43907ZM1.40018 5.13974C1.12404 5.13974 0.90018 5.3636 0.90018 5.63974C0.90018 5.91589 1.12404 6.13974 1.40018 6.13974V5.13974ZM13.4002 6.13974C13.6763 6.13974 13.9002 5.91589 13.9002 5.63974C13.9002 5.3636 13.6763 5.13974 13.4002 5.13974V6.13974ZM10.1995 11.2397L9.84599 10.8862C9.75222 10.98 9.69954 11.1071 9.69954 11.2397H10.1995ZM13.0795 8.35974L13.4331 8.00619C13.2378 7.81093 12.9212 7.81093 12.726 8.00619L13.0795 8.35974ZM14.9995 10.2797L15.3531 10.6333C15.4469 10.5395 15.4995 10.4124 15.4995 10.2797C15.4995 10.1471 15.4469 10.02 15.3531 9.92619L14.9995 10.2797ZM12.1195 13.1597V13.6597C12.2521 13.6597 12.3793 13.6071 12.4731 13.5133L12.1195 13.1597ZM10.1995 13.1597H9.69954C9.69954 13.4359 9.9234 13.6597 10.1995 13.6597V13.1597ZM2.60049 3.33984H12.2V2.33984H2.60049V3.33984ZM1.50066 10.4398L1.50049 4.43987L0.500488 4.4399L0.500659 10.4398L1.50066 10.4398ZM7.80045 11.5398L2.60064 11.5397L2.60062 12.5397L7.80043 12.5398L7.80045 11.5398ZM13.3001 4.43908L13.3002 6.03985L14.3002 6.03983L14.3001 4.43906L13.3001 4.43908ZM2.60049 2.33984C1.44067 2.33984 0.500455 3.28008 0.500488 4.4399L1.50049 4.43987C1.50047 3.83235 1.99296 3.33984 2.60049 3.33984V2.33984ZM12.2 3.33984C12.808 3.33984 13.3001 3.83186 13.3001 4.43908L14.3001 4.43907C14.3001 3.27884 13.3595 2.33984 12.2 2.33984V3.33984ZM0.500659 10.4398C0.500693 11.5996 1.44086 12.5397 2.60062 12.5397L2.60064 11.5397C1.99315 11.5397 1.50068 11.0473 1.50066 10.4398L0.500659 10.4398ZM1.40018 6.13974H13.4002V5.13974H1.40018V6.13974ZM10.5531 11.5933L13.4331 8.7133L12.726 8.00619L9.84599 10.8862L10.5531 11.5933ZM12.726 8.7133L14.646 10.6333L15.3531 9.92619L13.4331 8.00619L12.726 8.7133ZM14.646 9.92619L11.766 12.8062L12.4731 13.5133L15.3531 10.6333L14.646 9.92619ZM12.1195 12.6597H10.1995V13.6597H12.1195V12.6597ZM10.6995 13.1597V11.2397H9.69954V13.1597H10.6995Z"
      fill={color ?? '#676B76'}
    />
  </svg>
);

export const SettingIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.83733 2.83763L6.58525 1.76281C6.77219 1.49415 7.07878 1.33398 7.40607 1.33398H8.2619C8.58798 1.33398 8.89358 1.49297 9.08075 1.75998L9.81975 2.8142M5.83733 2.83763C5.60609 3.16752 5.22173 3.32918 4.81377 3.30036M5.83733 2.83763C5.60497 3.16673 5.22173 3.33052 4.81377 3.30036M4.81377 3.30036L3.48469 3.21692C3.16384 3.19677 2.85288 3.33211 2.64896 3.58064L2.11253 4.23441C1.89633 4.49791 1.82923 4.85338 1.93449 5.17755L2.31541 6.35068M2.31541 6.35068C2.3747 6.5429 2.38228 6.74883 2.33986 6.94332M2.31541 6.35068C2.37554 6.54256 2.38284 6.74808 2.33957 6.94531M2.33986 6.94332C2.29687 7.13551 2.20471 7.31698 2.06788 7.46393M2.33986 6.94332L2.33957 6.94531M2.06788 7.46393L1.19906 8.39837C0.970659 8.64402 0.880629 8.98781 0.959313 9.31388L1.14384 10.0786C1.22227 10.4036 1.45791 10.6679 1.77182 10.7829L2.96557 11.2204C3.1555 11.2939 3.31959 11.4134 3.44377 11.5639M2.06788 7.46393C2.20555 7.31818 2.29687 7.1373 2.33957 6.94531M3.44377 11.5639C3.56712 11.7148 3.65113 11.897 3.68372 12.0942M3.44377 11.5639C3.56824 11.7148 3.65253 11.8965 3.68372 12.0942M3.44377 11.5639L3.44181 11.5617C3.43366 11.5519 3.42495 11.5416 3.41652 11.532M3.68372 12.0942L3.88711 13.3436C3.94037 13.6708 4.15232 13.9503 4.453 14.0899L5.22356 14.4476C5.51463 14.5828 5.85287 14.57 6.13293 14.4133L7.26014 13.7827M7.26014 13.7827C7.43687 13.6834 7.63411 13.6337 7.83135 13.6334M7.26014 13.7827C7.3301 13.7429 7.40343 13.7111 7.47873 13.6873C7.59309 13.651 7.71222 13.6332 7.83135 13.6334M7.83135 13.6334C7.9339 13.6336 8.03645 13.6472 8.13648 13.674C8.22948 13.6989 8.31995 13.7352 8.40564 13.7827M7.83135 13.6334C8.02943 13.6331 8.22779 13.6829 8.40564 13.7827M8.40564 13.7827L9.59206 14.425C9.87334 14.5772 10.2105 14.5858 10.4991 14.4479L11.2664 14.0815C11.566 13.9384 11.775 13.6559 11.8243 13.3275L12.0057 12.1193M12.0057 12.1193C12.0369 11.921 12.1197 11.7374 12.2428 11.5852M12.0057 12.1193C12.0357 11.9205 12.1192 11.7373 12.2428 11.5852M12.2428 11.5852C12.365 11.4345 12.5271 11.3144 12.716 11.2402M12.2428 11.5852C12.3647 11.4339 12.5263 11.3135 12.716 11.2402M12.716 11.2402L13.9272 10.7655C14.2352 10.6448 14.4635 10.3796 14.5372 10.0571L14.7159 9.27458C14.7894 8.95295 14.6995 8.61579 14.4757 8.37343L13.5982 7.42329M13.5982 7.42329C13.4588 7.27583 13.3616 7.09968 13.3144 6.91247M13.5982 7.42329C13.5327 7.35442 13.4765 7.27913 13.4307 7.1993C13.3785 7.10865 13.3394 7.01216 13.3144 6.91247M13.3144 6.91247C13.268 6.72661 13.2709 6.52964 13.3296 6.339L13.707 5.12912C13.8074 4.80732 13.7389 4.45659 13.5249 4.19621L13.0072 3.56664C12.801 3.31575 12.4857 3.18067 12.1617 3.2044L10.8517 3.30036M10.8517 3.30036C10.6489 3.31468 10.4494 3.27604 10.2718 3.19291M10.8517 3.30036C10.6486 3.3155 10.4494 3.27655 10.2718 3.19291M10.2718 3.19291C10.0931 3.10872 9.93635 2.97925 9.81975 2.8142M10.2718 3.19291C10.0928 3.10903 9.93579 2.9799 9.81975 2.8142M2.33957 6.94531L2.34014 6.94239M10.0906 8.00773C10.0906 9.25103 9.06001 10.2589 7.78892 10.2589C6.51783 10.2589 5.48724 9.25103 5.48724 8.00773C5.48724 6.76443 6.51783 5.75656 7.78892 5.75656C9.06001 5.75656 10.0906 6.76443 10.0906 8.00773Z"
      stroke={color ?? '#676B76'}
    />
  </svg>
);

export const AddOnCardIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.22676 12.4264H2.82698C1.94334 12.4264 1.227 11.7101 1.22698 10.8265L1.22681 4.82661C1.22678 3.94293 1.94313 3.22656 2.82681 3.22656H12.4264C13.3101 3.22656 14.0265 3.94249 14.0265 4.82617L14.0265 7.62656M1.6265 6.02646H13.6265M13.089 12.7733L13.089 11.0892M13.089 11.0892L13.089 9.40507M13.089 11.0892H11.4049M13.089 11.0892H14.7731"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarType1Icon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.83331 11.7029V11.6465M8.20831 11.7029V11.6465M8.20831 8.64652V8.59012M11.2083 8.64652V8.59012M2.58331 5.64648H13.0833M3.94046 1.33398V2.45912M11.5833 1.33398V2.45898M11.5833 2.45898H4.08331C2.84067 2.45898 1.83331 3.46634 1.83331 4.70898V12.2091C1.83331 13.4517 2.84067 14.4591 4.08331 14.4591H11.5833C12.826 14.4591 13.8333 13.4517 13.8333 12.2091L13.8333 4.70898C13.8333 3.46634 12.826 2.45898 11.5833 2.45898Z"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarType2Icon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.58331 5.64648H13.0833M3.94046 1.33398V2.45912M11.5833 1.33398V2.45898M11.5833 2.45898H4.08331C2.84067 2.45898 1.83331 3.46634 1.83331 4.70898V12.2091C1.83331 13.4517 2.84067 14.4591 4.08331 14.4591H11.5833C12.826 14.4591 13.8333 13.4517 13.8333 12.2091L13.8333 4.70898C13.8333 3.46634 12.826 2.45898 11.5833 2.45898ZM13.8333 10.1465H9.70831M9.70831 10.1465H5.95831M9.70831 10.1465V13.8965M9.70831 10.1465V6.02152M5.95831 10.1465H1.83331M5.95831 10.1465V13.8965M5.95831 10.1465V6.02152"
      stroke={color ?? '#676B76'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilePdfIcon = ({ color }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.875 9.5C13.875 9.59946 13.8355 9.69484 13.7652 9.76517C13.6948 9.83549 13.5995 9.875 13.5 9.875H11.875V11.125H13C13.0995 11.125 13.1948 11.1645 13.2652 11.2348C13.3355 11.3052 13.375 11.4005 13.375 11.5C13.375 11.5995 13.3355 11.6948 13.2652 11.7652C13.1948 11.8355 13.0995 11.875 13 11.875H11.875V13C11.875 13.0995 11.8355 13.1948 11.7652 13.2652C11.6948 13.3355 11.5995 13.375 11.5 13.375C11.4005 13.375 11.3052 13.3355 11.2348 13.2652C11.1645 13.1948 11.125 13.0995 11.125 13V9.5C11.125 9.40054 11.1645 9.30516 11.2348 9.23484C11.3052 9.16451 11.4005 9.125 11.5 9.125H13.5C13.5995 9.125 13.6948 9.16451 13.7652 9.23484C13.8355 9.30516 13.875 9.40054 13.875 9.5ZM5.625 10.75C5.625 11.181 5.4538 11.5943 5.14905 11.899C4.8443 12.2038 4.43098 12.375 4 12.375H3.375V13C3.375 13.0995 3.33549 13.1948 3.26517 13.2652C3.19484 13.3355 3.09946 13.375 3 13.375C2.90054 13.375 2.80516 13.3355 2.73483 13.2652C2.66451 13.1948 2.625 13.0995 2.625 13V9.5C2.625 9.40054 2.66451 9.30516 2.73483 9.23484C2.80516 9.16451 2.90054 9.125 3 9.125H4C4.43098 9.125 4.8443 9.29621 5.14905 9.60095C5.4538 9.9057 5.625 10.319 5.625 10.75ZM4.875 10.75C4.875 10.5179 4.78281 10.2954 4.61872 10.1313C4.45462 9.96719 4.23206 9.875 4 9.875H3.375V11.625H4C4.23206 11.625 4.45462 11.5328 4.61872 11.3687C4.78281 11.2046 4.875 10.9821 4.875 10.75ZM10.125 11.25C10.125 11.8136 9.90112 12.3541 9.5026 12.7526C9.10409 13.1511 8.56359 13.375 8 13.375H7C6.90054 13.375 6.80516 13.3355 6.73484 13.2652C6.66451 13.1948 6.625 13.0995 6.625 13V9.5C6.625 9.40054 6.66451 9.30516 6.73484 9.23484C6.80516 9.16451 6.90054 9.125 7 9.125H8C8.56359 9.125 9.10409 9.34888 9.5026 9.7474C9.90112 10.1459 10.125 10.6864 10.125 11.25ZM9.375 11.25C9.375 10.8853 9.23014 10.5356 8.97227 10.2777C8.71441 10.0199 8.36467 9.875 8 9.875H7.375V12.625H8C8.36467 12.625 8.71441 12.4801 8.97227 12.2223C9.23014 11.9644 9.375 11.6147 9.375 11.25ZM2.625 7V2.5C2.625 2.26794 2.71719 2.04538 2.88128 1.88128C3.04538 1.71719 3.26794 1.625 3.5 1.625H9.5C9.54934 1.62496 9.59819 1.63466 9.64377 1.65353C9.68935 1.67241 9.73076 1.70009 9.76563 1.735L13.2656 5.235C13.3357 5.30536 13.3751 5.40067 13.375 5.5V7C13.375 7.09946 13.3355 7.19484 13.2652 7.26517C13.1948 7.33549 13.0995 7.375 13 7.375C12.9005 7.375 12.8052 7.33549 12.7348 7.26517C12.6645 7.19484 12.625 7.09946 12.625 7V5.875H9.5C9.40054 5.875 9.30516 5.83549 9.23484 5.76517C9.16451 5.69484 9.125 5.59946 9.125 5.5V2.375H3.5C3.46685 2.375 3.43505 2.38817 3.41161 2.41161C3.38817 2.43505 3.375 2.46685 3.375 2.5V7C3.375 7.09946 3.33549 7.19484 3.26517 7.26517C3.19484 7.33549 3.09946 7.375 3 7.375C2.90054 7.375 2.80516 7.33549 2.73483 7.26517C2.66451 7.19484 2.625 7.09946 2.625 7ZM9.875 5.125H12.095L9.875 2.905V5.125Z"
      fill={color ?? '#1047DC'}
    />
  </svg>
);
